<app-page>
    <div class="col-12 xl:col-10 m-auto px-3 mt-8 md:border-round-3xl h-full p-8 bg-slate-50">
        <div class="content md:px-4 flex flex-column align-items-center">
            <ng-container *ngFor="let content of pageContent; let i = index; trackBy: trackByIndex">
                <ng-container *ngIf="content.errorCode == 400">
                    <h1 class="text-2xl md:text-4xl text-slate-800">{{content.errorHeader}}</h1>

                    <ng-container *ngIf="content.subheaderText">
                        <h4 class="text-1xl md:text-2xl text-slate-800 custom-bold" [innerHTML]="content.subheaderText"></h4>
                    </ng-container>


                    <ng-container *ngIf="content.paragraphContent">
                        <p class="text-lg text-slate-800" [innerHTML]="content.paragraphContent"></p>
                    </ng-container>

                    <ng-container *ngIf="content.linkLabels.length > 0">
                        <ul class="body-copy-lg">
                            <li *ngFor="let link of content.linkLabels; let i = index; trackBy: trackByIndex">
                                <a href="{{link.linkUrl}}"
                                    class="no-underline text-blue-600 hover:underline">{{link.linkLabel}}</a>
                            </li>
                        </ul>
                    </ng-container>
                </ng-container>
            </ng-container>
            <p-button label="Visit our homepage" severity="primary" [rounded]="true" (click)="navigateToHome()"
                data-auto-id="visit-out-homepage" class="flex align-items-center m-auto mb-2"
                styleClass=" white-space-nowrap md:ml-2 lg:ml-2 sm:ml-0" />
        </div>
    </div>
</app-page>